import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

const EmptyBase = ({ title, content, userType }) => {
  const ctaContent =
    userType === "client" ? (
      <Link className="btn btn-primary" to="/start-a-project/">
        Start a new project
      </Link>
    ) : (
      <Link
        className="btn btn-tertiary"
        to="/explore/?explore_projects_filter_checkboxes_status=open"
      >
        Find projects
      </Link>
    );

  return (
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>{title}</h3>
        {content || <div className="empty-state-cta">{ctaContent}</div>}
      </div>
    </div>
  );
};

EmptyBase.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  userType: PropTypes.string.isRequired,
};

export const EmptyDraft = (props) => (
  <EmptyBase {...props} title="You don't have any drafts right now." />
);

export const EmptyActive = (props) => (
  <EmptyBase {...props} title="You don't have any active projects right now." />
);

export const EmptyWrapup = (props) => (
  <EmptyBase
    {...props}
    title="You don't have any projects in wrap-up right now."
    content={
      <p>
        {props.userType === "client"
          ? "When you award a project, it will appear here."
          : "When you receive an award in a project, the project will appear here."}{" "}
        <br />
        To understand how wrap-ups work, check out our Illustrated Guides to{" "}
        <Link to="/help/guides/design-projects-wrapup/">Design</Link> and
        <Link to="/help/guides/naming-projects-wrapup/"> Naming</Link> Wrap-ups.
      </p>
    }
  />
);

EmptyWrapup.propTypes = {
  userType: PropTypes.string.isRequired,
};

export const EmptyCompleted = (props) => (
  <EmptyBase {...props} title="You haven't completed any projects yet." />
);

export const EmptyInvited1to1Negotiations = (props) => (
  <EmptyBase
    {...props}
    // different title to account for no items *in the current page*
    title="No 1-to-1 negotiations to show."
  />
);

export const EmptyInvitedProjectInvites = (props) => (
  <EmptyBase
    {...props}
    // different title to account for no items *in the current page*
    title="No project invites to show."
  />
);

export const EmptyWatchlist = (props) => (
  <EmptyBase {...props} title="You aren't watching any projects." />
);

export const EmptyParticipating = (props) => (
  <EmptyBase
    {...props}
    title="You aren't participating in any projects right now."
  />
);

export const EmptyWon = (props) => (
  <EmptyBase {...props} title="You haven't won any projects yet." />
);

export const EmptyHistory = (props) => (
  <EmptyBase {...props} title="You don't have any projects in history yet." />
);
